import { render, staticRenderFns } from "./Freight.vue?vue&type=template&id=b34ae0de&scoped=true&"
import script from "./Freight.vue?vue&type=script&lang=js&"
export * from "./Freight.vue?vue&type=script&lang=js&"
import style0 from "./Freight.vue?vue&type=style&index=0&id=b34ae0de&lang=scss&scoped=true&"
import style1 from "./Freight.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34ae0de",
  null
  
)

export default component.exports